module.exports = __webpack_public_path__ + "static/img/n-three.c5befaa2.webp";